import React from 'react';
import { RefreshCcw, DownloadCloud } from 'lucide-react';
import { useVersionCheck } from '@/src/hooks/useVersionCheck';
import { Button } from '../ui/Button';

export function UpdateBanner() {
  const { updateAvailable, reloadToUpdate } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] animate-in slide-in-from-bottom-5 fade-in duration-300">
      <div className="bg-navy-900 border-2 border-black dark:border-white border-navy-800 text-white px-4 py-3 rounded-none shadow-2xl flex items-center gap-4 max-w-sm w-max whitespace-nowrap lg:max-w-md">
        <div className="bg-brand-primary/20 text-brand-primary p-2 rounded-none">
          <DownloadCloud size={20} />
        </div>
        
        <div className="flex-1 min-w-0 pr-2">
          <p className="text-sm font-medium">New version available</p>
          <p className="text-xs text-navy-200">Refresh to get the latest features.</p>
        </div>

        <Button 
          variant="primary" 
          size="sm" 
          onClick={reloadToUpdate}
          className="shrink-0 group"
        >
          <RefreshCcw size={14} className="mr-2 group-hover:rotate-180 transition-transform duration-500" />
          Update Now
        </Button>
      </div>
    </div>
  );
}
